<div class="outer-container">
  <div class="menu-row-start">
    <div class="radio-container">
      <input
        class="radio-input"
        type="radio"
        name="basic-hyperlink-radio"
        attr.data-test="basic-hyperlink-radio"
        id="basic"
        value="basic"
        [ngModel]="urlType"
        (ngModelChange)="urlTypeSelected('basic')"
      />
      <label for="basic" class="radio-label">
        <span>Basic hyperlink</span>
      </label>
    </div>
    <div class="radio-container">
      <input
        class="radio-input"
        type="radio"
        name="custom-hyperlink-radio"
        attr.data-test="custom-hyperlink-radio"
        id="custom"
        value="custom"
        [ngModel]="urlType"
        (ngModelChange)="urlTypeSelected('custom')"
      />
      <label for="custom" class="radio-label">
        <span>Custom</span>
      </label>
    </div>
  </div>
  <div class="menu-row">
    <mode-labeled-menu
      data-test="url-display-menu"
      class="menu-cell"
      label="Display"
      menuClass="url-format-pane-menu"
      [selected]="selectedDisplay"
      [menuItems]="UrlDisplayMenuItems"
      (menuChange)="onChangeDisplay($event)"
    ></mode-labeled-menu>
    <mode-labeled-menu
      data-test="url-link-color-menu"
      class="menu-cell"
      label="Color"
      menuClass="url-format-pane-menu"
      [selected]="selectedLinkColor"
      [menuItems]="UrlLinkColorMenuItems"
      (menuChange)="onChangeLinkColor($event)"
    ></mode-labeled-menu>
  </div>
  <ng-container *ngIf="urlType === 'custom'">
    <div class="divider"></div>
    <p class="link-custom-formats">
      The inputs below modify all values in your column. If you want to use the column's values as the display text or
      URL, leave that input blank.
    </p>
    <div class="menu-input">
      <label class="form-control-label">Display text</label>
      <input
        data-test="display-text-input"
        placeholder="Enter display text..."
        [ngModel]="format.linkDisplayText"
        (ngModelChange)="onChangeDisplayText($event)"
        class="form-control form-control-sm precision"
        type="text"
      />
    </div>
    <div class="menu-input">
      <label class="form-control-label">URL address</label>
      <input
        data-test="url-address-input"
        placeholder="Enter a URL address..."
        [ngModel]="format.linkURLPattern"
        (blur)="onChangeUrlAddress($event?.target?.value)"
        (keyup)="onUrlAddressKeyUp($event)"
        class="form-control form-control-sm precision"
        type="text"
      />
    </div>
    <p class="field-description">{{ UrlAddressUsageInfo }}</p>
  </ng-container>
  <div class="menu-row-end">
    <mode-capra-icon
      icon="icon-info-outline"
      class="info-icon"
      capraTooltip
      [tooltipContent]="EncodeUrlInfoTooltip"
      [tooltipInteractive]="false"
      [tooltipDelay]="[750, 0]"
      [tooltipSize]="'mini'"
      tooltipPlacement="bottom"
    ></mode-capra-icon>
    <span>Encode URL</span>
    <mode-toggle-switch
      class="encode-url-toggle-switch"
      [state]="format.shouldEncodeURL"
      (stateChange)="toggleEncodeUrl($event)"
      data-test="toggle-encode-url"
    ></mode-toggle-switch>
  </div>
</div>
